import { FormFields, ValidationValue, Validator } from 'types/validation'

export const VALIDATION_ERRORS_ENUM = {
  NOT_VALID: 'Please, enter valid email. Example: example@site.com',
  CANNOT_BE_EMPTY: 'This field is required.',
  EMAILS_NOT_MATCH: 'Emails should match.',
}

export const emailValidators: Validator[] = [
  {
    name: 'Is field empty',
    isValid: ({ value }: ValidationValue): boolean => value && !!value.length,
    errorMessage: VALIDATION_ERRORS_ENUM.CANNOT_BE_EMPTY,
  },
  {
    name: 'Is email valid',
    isValid: ({ value }: ValidationValue): boolean => {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line

      return re.test(String(value).toLowerCase())
    },
    errorMessage: VALIDATION_ERRORS_ENUM.NOT_VALID,
  },
]

export const repeatEmailValidators: Validator[] = [
  {
    name: 'Is field empty',
    isValid: ({ value }: ValidationValue): boolean => value && !!value.length,
    errorMessage: VALIDATION_ERRORS_ENUM.CANNOT_BE_EMPTY,
  },
  {
    name: 'Is eamils are equal',
    isValid: ({ value }: ValidationValue, formFields: FormFields): boolean => {
      const emailValue = formFields['email'].value

      return emailValue === value
    },
    errorMessage: VALIDATION_ERRORS_ENUM.EMAILS_NOT_MATCH,
  },
]

export const validateEmail = (formFields: FormFields, value: ValidationValue): string => {
  const result = emailValidators.reduce((result: string[], validator: Validator) => {
    const errorMessage = !validator.isValid(value) && validator.errorMessage

    errorMessage && result.push(errorMessage)

    return result
  }, [])

  return result.length ? result[0] : ''
}

export const validateRepeatEmail = (formFields: FormFields, value: ValidationValue): string => {
  const result = repeatEmailValidators.reduce((result: string[], validator: Validator) => {
    const errorMessage = !validator.isValid(value, formFields) && validator.errorMessage

    errorMessage && result.push(errorMessage)

    return result
  }, [])

  return result.length ? result[0] : ''
}
